import { useState, useCallback } from 'react';
import { getQueryStringValue, setQueryStringValue } from './queryString';

export function useQueryState(key: any, initialValue?: any) {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(
    (newValue: any) => {
      setValue(newValue);
      setQueryStringValue(key, newValue);
    },
    [key]
  );

  return [value, onSetValue];
}

export default useQueryState;
